import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import NavigationBar from "../layout/NavigationBar";
import Footer from "../layout/footer";

function AddCategory() {
  const [searchParams] = useSearchParams();
  const categoryId = searchParams.get("id");
  const [category, setCategory] = useState("");
  const [subcategory, setSubcategory] = useState("");
  const [subcategories, setSubcategories] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [isFormProcessing, setIsFormProcessing] = useState(false);
  const [type, setType] = useState("");
  
  // New state variables for missing fields
  const [columnHeader, setColumnHeader] = useState("");
  const [columnPriority, setColumnPriority] = useState(0);
  const [isFeatured, setIsFeatured] = useState(false);
  const [isTrending, setIsTrending] = useState(false);
  const [displayOrder, setDisplayOrder] = useState(0);

  const navigate = useNavigate();

  // Auto-generate column header when category changes
  // useEffect(() => {
  //   if (category.trim() !== "" && columnHeader === "") {
  //     setColumnHeader(`${category} Collection`);
  //   }
  // }, [category, columnHeader]);

  const handleAddCategory = async (e) => {
    e.preventDefault();

    setIsFormProcessing(true);
    let valid = true;

    // Validate form fields
    if (category.trim() === "") {
      setErrorMessage("Category is required");
      valid = false;
    } else if (subcategory.trim() === "") {
      setErrorMessage("Subcategory is required");
      valid = false;
    }  else if (columnHeader.trim() === "") {
      setErrorMessage("Column Header is required");
      valid = false;
    } else {
      setErrorMessage("");
    }

    if (!valid) {
      setIsFormProcessing(false);
      return;
    }

    try {
      const apiUrl = categoryId
        ? `${process.env.REACT_APP_APIURL}category/update`
        : `${process.env.REACT_APP_APIURL}category/create`;

      const payload = {
        category: category,
        subcategory: subcategory,
        category_id: categoryId ? categoryId : "",
        type: 'gift',
        column_header: columnHeader,
        column_priority: columnPriority,
        is_featured: isFeatured,
        is_trending: isTrending,
        display_order: displayOrder,
      };

      axios
        .post(apiUrl, payload)
        .then((res) => {
          if (res.data.status === "success") {
            setSuccessMessage(
              categoryId
                ? "Category updated successfully!"
                : "Category added successfully!"
            );
            setTimeout(() => {
              setSuccessMessage("");
              navigate("/category");
            }, 2000);
          } else {
            setErrorMessage("Failed to add/update category");
          }
        })
        .catch((err) => {
          console.error("Category creation/update error:", err);
          setErrorMessage("Failed to add/update category");
        })
        .finally(() => setIsFormProcessing(false));
    } catch (err) {
      console.error("Error:", err);
      setErrorMessage("Error while processing the form");
      setIsFormProcessing(false);
    }
  };

  return (
    <div className="wrapper">
      <header>
        <NavigationBar />
      </header>

      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1 className="m-0 txt_lft">
                  {categoryId ? "Edit Category" : "Add Category"}
                </h1>
              </div>
            </div>
          </div>
        </div>

        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="frmwdth_cntr">
                <div className="col-lg-12">
                  <div className="card card-primary card-outline">
                    <form
                      className="form-horizontal"
                      onSubmit={handleAddCategory}
                    >
                      <div className="card-body">
                        {/* Category Field */}
                        <div className="form-group row">
                          <label className="col-12 col-md-4 col-form-label">
                            Category<span className="f_red">*</span>
                          </label>
                          <div className="col-12 col-md-8">
                            <input
                              className="form-control"
                              type="text"
                              value={category}
                              onChange={(e) => setCategory(e.target.value)}
                              placeholder="Enter category"
                            />
                          </div>
                        </div>

                        {/* Subcategory Field */}
                        <div className="form-group row">
                          <label className="col-12 col-md-4 col-form-label">
                            Subcategory<span className="f_red">*</span>
                          </label>
                          <div className="col-12 col-md-8">
                            <input
                              className="form-control"
                              type="text"
                              value={subcategory}
                              onChange={(e) => setSubcategory(e.target.value)}
                              placeholder="Enter subcategory"
                            />
                          </div>
                        </div>

                        {/* Type Field */}
                        {/* <div className="form-group row">
                          <label className="col-12 col-md-4 col-form-label">
                            Type<span className="f_red">*</span>
                          </label>
                          <div className="col-12 col-md-8">
                            <select
                              className="form-control"
                              value={type}
                              onChange={(e) => setType(e.target.value)}
                            >
                              <option value="">Select type</option>
                              <option value="greeting_card">Greeting card</option>
                              <option value="gift">Product</option>
                            </select>
                          </div>
                        </div> */}

                        {/* Column Header Field */}
                        <div className="form-group row">
                          <label className="col-12 col-md-4 col-form-label">
                            Column Header<span className="f_red">*</span>
                          </label>
                          <div className="col-12 col-md-8">
                            <input
                              className="form-control"
                              type="text"
                              value={columnHeader}
                              onChange={(e) => setColumnHeader(e.target.value)}
                              placeholder="Enter column header"
                            />
                            {/* <small className="form-text text-muted">
                              Auto-generated as "{category} Collection" if left empty
                            </small> */}
                          </div>
                        </div>

                        {/* Column Priority Field */}
                        <div className="form-group row">
                          <label className="col-12 col-md-4 col-form-label">
                            Column Priority
                          </label>
                          <div className="col-12 col-md-8">
                            <input
                              className="form-control"
                              type="number"
                              value={columnPriority}
                              onChange={(e) => setColumnPriority(parseInt(e.target.value) || 0)}
                              placeholder="Enter column priority (0-100)"
                              min="0"
                            />
                          </div>
                        </div>

                        {/* Display Order Field */}
                        <div className="form-group row">
                          <label className="col-12 col-md-4 col-form-label">
                            Display Order
                          </label>
                          <div className="col-12 col-md-8">
                            <input
                              className="form-control"
                              type="number"
                              value={displayOrder}
                              onChange={(e) => setDisplayOrder(parseInt(e.target.value) || 0)}
                              placeholder="Enter display order"
                              min="0"
                            />
                          </div>
                        </div>

                        {/* Featured and Trending Checkboxes */}
                        <div className="form-group row">
                          <label className="col-12 col-md-4 col-form-label">
                            Settings
                          </label>
                          <div className="col-12 col-md-8">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id="isFeatured"
                                checked={isFeatured}
                                onChange={(e) => setIsFeatured(e.target.checked)}
                              />
                              <label className="form-check-label" htmlFor="isFeatured">
                                Featured Category
                              </label>
                            </div>
                            <div className="form-check mt-2">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id="isTrending"
                                checked={isTrending}
                                onChange={(e) => setIsTrending(e.target.checked)}
                              />
                              <label className="form-check-label" htmlFor="isTrending">
                                Trending Category
                              </label>
                            </div>
                          </div>
                        </div>

                        {/* Error Message */}
                        {errorMessage && (
                          <div className="text-danger">{errorMessage}</div>
                        )}

                        {/* Success Message */}
                        {successMessage && (
                          <div className="text-success">{successMessage}</div>
                        )}
                      </div>

                      {/* Form Submit Button */}
                      <div className="card-footer text-center">
                        <button
                          type="submit"
                          className="btn btn-primary"
                          disabled={isFormProcessing}
                        >
                          {categoryId ? "Update" : "Add"}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default AddCategory;